/**
 * Order Status Constants
 * Defines all possible order statuses in the system
 */
export const ORDER_STATUS = {
  AWAITING_PAYMENT: 1,
  PAYMENT_RECEIVED: 2,
  DESPATCHED: 3,
  CANCELLED: 4,
  PAYMENT_MADE: 5,
};

/**
 * Payment Method Options
 */
export const PAYMENT_METHODS = [
  { value: "BACS", label: "BACS" },
  { value: "Credit/Debit Card", label: "Credit/Debit Card" },
];

/**
 * Order Status Display Configuration
 * Maps status codes to display properties
 */
export const ORDER_STATUS_CONFIG = {
  [ORDER_STATUS.DESPATCHED]: {
    text: "Sent/Despatched",
    className: "light-green-warning",
  },
  [ORDER_STATUS.PAYMENT_RECEIVED]: {
    text: "Payment Received",
    className: "light-blue-warning",
  },
  [ORDER_STATUS.PAYMENT_MADE]: {
    text: "Payment Made",
    className: "red-warning",
  },
  [ORDER_STATUS.AWAITING_PAYMENT]: {
    text: "Awaiting Payment",
    className: "yellow-warning",
  },
  [ORDER_STATUS.CANCELLED]: {
    text: "Cancelled",
    className: "dark-grey-warning",
  },
};

/**
 * Date Format Constants
 */
export const DATE_FORMATS = {
  ORDER_DATE: "dddd DD MMMM YYYY - HH:mm",
  ATTACHMENT_DATE: "ddd DD MMM YY @ HH:mm",
  INPUT_DATE: "YYYY-MM-DD",
};
